module.exports = __webpack_public_path__ + "imgs/ww-leaf.437f457892b3f7dad8c2c58752956344.jpg";